<template>
  <div>
    <div class="table-container-v3 margin-25">
      <table class="table table-v3 is-fullwidth is-striped">
        <thead>
          <tr>
            <th>ID</th>
            <th>Etiqueta</th>
            <th>Slug</th>
            <th>Estatus</th>
            <th>Fecha de creación</th>
            <th>Acciones</th>
          </tr>
        </thead>
        <tbody v-if="!isLoading && cmsContent.length">
          <tr v-for="(item, index) in cmsContent" :key="index">
            <td class="has-text-centered">{{ item.id }}</td>
            <td class="has-text-centered">{{ item.name }}</td>
            <td class="has-text-centered">
              {{ item.slug }}
            </td>
            <td class="has-text-centered">
              <span class="is-status" :class="item.enabled ? 'is-status-active' : 'is-status-inactive'">
                {{ item.enabled ? 'Activo' : 'Borrador' }}
              </span>
            </td>
            <td class="has-text-centered">
              {{ humanDate(item.createdAt, 'DD-MMMM-YYYY', false, 'es') }}
            </td>
            <td class="has-text-centered">
              <div class="dropdown">
                <a
                  id="panelNavBurger"
                  role="button"
                  data-target="panelNavMenu"
                  aria-expanded="false"
                  aria-label="menu"
                  class="dropbtn"
                >
                  <i class="fas fa-ellipsis-v" />
                </a>
                <div class="dropdown-content">
                  <a class="navbar-item">
                    <i class="show-on-hover fas fa-chevron-right" />
                    Ver detalle
                  </a>
                  <a class="navbar-item" v-if="['admin', 'developer', 'manager', 'compliance'].includes(role.code)">
                    <i class="show-on-hover fas fa-chevron-right" />
                    Editar
                  </a>
                  <a class="navbar-item" @click="openShowModalEnabled(item)"  v-if="['admin', 'developer', 'manager', 'compliance'].includes(role.code)">
                    <i class="show-on-hover fas fa-chevron-right" />
                    {{ item.enabled ? 'Desactivar' : 'Activar' }}
                  </a>
                </div>
              </div>
            </td>
          </tr>
        </tbody>
        <tbody v-else-if="isLoading">
          <tr>
            <td colspan="7" class="has-text-centered">
              <div class="lds-dual-ring"></div>
            </td>
          </tr>
        </tbody>
        <tbody v-else>
          <tr>
            <td colspan="7" class="has-text-centered -text3 -gray">
              Sin información
            </td>
          </tr>
        </tbody>
      </table>
    </div>
      <!-- <div class="column is-12 has-text-centered">
        <paginator
          :page="pagination.pageNumber"
          :pages="pagination.totalPages"
          :loading="false"
          :action="fetchEmailTemplates"
        />
      </div> -->
    <modal-enabled
      v-if="showModalEnabled"
      :close="openShowModalEnabled"
      :active="showModalEnabled"
      :item="elementActive"
      :reload="getCmsPagesLocal"
    />

    <!-- <modal-detail
      v-if="showModalDetail"
      :close="openShowModalDetail"
      :active="showModalDetail"
      :item="elementActive"
    /> -->

    <!-- <modal-edit
      v-if="showModalEdit"
      :close="openShowModalEdit"
      :active="showModalEdit"
      :item="elementActive"
      :reload="getCmsPagesLocal"
    /> -->

    <modal-add
      v-if="showModalAdd"
      :close="openShowModalAdd"
      :active="showModalAdd"
      :reload="getCmsPagesLocal"
    />
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import mixins from '@/mixins/formats'

export default {
  name: 'Emails',
  mixins: [mixins],
  components: {
    ModalEnabled: () => import('@/components/Profile/CMS/ModalEnabledPages.vue'),
    // ModalDetail: () => import('@/components/Profile/CMS/ModalDetailPages.vue'), Probable nombre del detalle
    // ModalEdit: () => import('@/components/Profile/CMS/ModalEditPages.vue'),  Probable nombre del edit
    ModalAdd: () => import('@/components/Profile/CMS/ModalAddPages.vue')
    // Paginator: () => import('@/components/ui/BasePagination')
  },
  data () {
    return {
      isLoading: false,
      cmsContent: [],
      showModalEnabled: false,
      showModalDetail: false,
      showModalEdit: false,
      showModalAdd: false,
      elementActive: null,
      pagination: {
        pageNumber: 1,
        perPage: 10,
        totalPages: 1
      }
    }
  },
  computed: {
    ...mapState({
      systemConfiguration: state => state.configuration,
      profile: (state) => state.financialCompany.financialCompany,
      role: state => state.financialCompany.role
    })
  },
  async mounted () {
    await this.getCmsPagesLocal()
    this.$root.$on('open-add-modal', this.openShowModalAdd)
  },
  beforeDestroy () {
    this.$root.$off('open-add-modal')
  },
  methods: {
    ...mapActions(['getCmsPages']),
    async getCmsPagesLocal (page = 1) {
      this.isLoading = true
      try {
        const response = await this.getCmsPages({ pageNumber: page, perPage: 30 })
        this.cmsContent = response?.cmsPages
      } catch (err) {
        this.cmsContent = []
      } finally {
        this.isLoading = false
      }
    },
    openShowModalEnabled (element) {
      this.elementActive = element || null
      this.showModalEnabled = !this.showModalEnabled
    },
    // openShowModalDetail (element) {
    //   this.elementActive = element || null
    //   this.showModalDetail = !this.showModalDetail
    // },
    // openShowModalEdit (element) {
    //   this.elementActive = element || null
    //   this.showModalEdit = !this.showModalEdit
    // },
    openShowModalAdd () {
      this.showModalAdd = !this.showModalAdd
    }
  }
}
</script>

<style lang="scss" scoped>
.section {
  padding-top: 1rem;
  padding-left: 1rem;
  padding-right: 1rem;
}
h3 {
  font-size: 1.1rem !important;
  margin-top: 1rem;
  color: #484c53;
  font-weight: 600;
  padding-left: 0.5rem;
}
a.disabled {
  pointer-events: none;
  cursor: default;
  color: #dddddd !important;
  i {
    color: #dddddd !important;
  }
}
.margin-25 {
  margin-top: 25px !important;
}
.title-actions {
  justify-content: flex-end;
}
.position-absolute {
  position: absolute !important;
}
</style>
